import React from "react";
import { Grid, CircularProgress, Theme, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
	container: {
		height: "100vh"
	}
}));

function FallBackLoading() {
	const classes = useStyles();

	return (
		<Grid
			container
			justify="center"
			alignItems="center"
			className={classes.container}
		>
			<CircularProgress />
		</Grid>
	);
}

export default FallBackLoading;
